import { 
    LOAD_LIST_COMPANY, LOAD_A_COMPANY, ADD_NEW_COMPANY, UPDATE_A_COMPANY, DELETE_A_COMPANY, CLEAR_A_COMPANY_DETAIL, CLEAR_COMPANY_ACTION_STATUS,
    SET_COMPANY_LOGO_FILE, UPLOAD_COMPANY_LOGO_FILE, DELETE_COMPANY_LOGO_FILE
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    companyList: [],
    companyDetail: null,
    companyLogoUrl: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_COMPANY: {
            return {
                ...state,
                companyList: action.payload,
            }
        }

        case LOAD_A_COMPANY: {
            return {
                ...state,
                companyDetail: action.payload
            }
        }

        case ADD_NEW_COMPANY: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                companyList: [
                    action.payload.data,
                    ...state.companyList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_COMPANY: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                companyList: state.companyList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_COMPANY: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                companyList: state.companyList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }
        
        case UPLOAD_COMPANY_LOGO_FILE: {
            return {
                ...state,
                companyLogoUrl: action.payload,
            }
        }

        case SET_COMPANY_LOGO_FILE: {
            return {
                ...state,
                companyLogoUrl: action.payload,
            }
        }
        
        case DELETE_COMPANY_LOGO_FILE: {
            return {
                ...state,
                companyLogoUrl: null,
            }
        }

        case CLEAR_A_COMPANY_DETAIL: {
            return {
                ...state,
                companyDetail: null,
            }
        }
        
        case CLEAR_COMPANY_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}